import { render, staticRenderFns } from "./TransaccionesBodega.vue?vue&type=template&id=2eb26a0a&"
import script from "./TransaccionesBodega.vue?vue&type=script&lang=js&"
export * from "./TransaccionesBodega.vue?vue&type=script&lang=js&"
import style0 from "./TransaccionesBodega.vue?vue&type=style&index=0&id=2eb26a0a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports